<div class="d-flex h-100 flex-column">
  <div
    class="position-relative chat-window-container h-100"
    style="min-height: 600px;"
    *ngIf="currentThread != null"
  >
    <app-chat-window [threadSubject]="currentThreadSubject"></app-chat-window>
    <button
      nbButton
      ghost
      status="default"
      class="back-btn"
      (click)="closeChatWindow()"
    >
      <nb-icon icon="close"></nb-icon>
    </button>
  </div>
  <nb-card *ngIf="currentThread == null" class="flex-grow-1 m-0">
    <div class="header px-4 py-3">
      All Chats
      <button
        nbButton
        ghost
        status="default"
        class="back-btn"
        (click)="onClose.emit()"
      >
        <nb-icon icon="close"></nb-icon>
      </button>
      <nb-form-field class="m-3 d-none">
        <input
          nbInput
          fullWidth
          shape="round"
          class="rounded-pill"
          (input)="onSearchValueChanged($event)"
        />
        <button nbSuffix nbButton ghost shape="round">
          <nb-icon icon="search-outline" pack="eva"> </nb-icon>
        </button>
      </nb-form-field>
    </div>

    <app-threads
      [search]="threadSearch"
      (onThreadSelected)="onCurrentThreadChanged($event)"
    ></app-threads>
  </nb-card>
</div>
